import React from "react";
import { Link } from "react-router-dom";

const Contact = () => {
  return (
    <main>
      <section className="pt-[120px] pb-[100px]" id="aboutus">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid items-end gap-6 lg:grid-cols-2 lg:gap-10">
            {/* Left Content */}
            <div>

              {/* Badge */}
              <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-[#1AAD9D50] bg-[#F4FFFE] px-4 py-2" data-aos="fade-down">
                <span className="relative flex h-2 w-2">

                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#1AAD9D] opacity-75" />
                  <span className="relative inline-flex h-2 w-2 rounded-full bg-[#1AAD9D]" />
                </span>
                <span className="text-sm font-medium text-[#1AAD9D]">
                  Contact Us
                </span>
              </div>
              <h2 className="mt-4 font-display text-3xl font-bold text-gray-900 lg:text-4xl"  data-aos="fade-up" data-aos-delay={100}>
                Contact Our Care Advisors
              </h2>
              <p className="mt-4 text-lg text-gray-600"  data-aos="fade-up" data-aos-delay={200}>
                Connect with us today — we’re here to make your healthcare journey simple and stress-free.
              </p>

              <div className="mx-auto mt-4 grid max-w-2xl grid-cols-1 gap-6 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:grid-cols-2">
                <div className="flex flex-col gap-y-12 rounded-2xl border border-[#f0f0f0] p-6 shadow-sm"  data-aos="fade-up" data-aos-delay={300}>
                  <div className="flex h-11 w-11 flex-none items-center justify-center rounded-lg btn-gradient shadow-sm">
                    <svg
                      className="h-6 w-6 text-white"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                    >
                      <path
                        d="M3 11C3 9.11438 3 8.17157 3.58579 7.58579C4.17157 7 5.11438 7 7 7H8H16H17C18.8856 7 19.8284 7 20.4142 7.58579C21 8.17157 21 9.11438 21 11V17C21 18.8856 21 19.8284 20.4142 20.4142C19.8284 21 18.8856 21 17 21H16H8H7C5.11438 21 4.17157 21 3.58579 20.4142C3 19.8284 3 18.8856 3 17V11Z"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinejoin="round"
                      />
                      <path
                        d="M8 21V5C8 3.89543 8.89543 3 10 3H14C15.1046 3 16 3.89543 16 5V21"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <div className="flex flex-auto flex-col items-start">
                    <div className="flex-auto">
                      <h3 className="text-xl font-medium tracking-tight text-gray-900">
                        Contact sales
                      </h3>
                    </div>
                    <a
                      href="mailto:info@opdcover.com "
                      className="inline-block text-base font-semibold gradient-text2"
                    >
                      info@opdcover.com
                    </a>
                  </div>
                </div>
                <div className="flex flex-col gap-y-12 rounded-2xl border border-[#f0f0f0] p-6 shadow-sm" data-aos="fade-up" data-aos-delay={400}>
                  <div className="flex h-11 w-11 flex-none items-center justify-center rounded-lg btn-gradient shadow-sm">
                    <svg
                      className="h-6 w-6 text-white"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                    >
                      <path
                        d="M3 5.5C3 14.0604 9.93959 21 18.5 21C18.8862 21 19.2691 20.9859 19.6483 20.9581C20.0834 20.9262 20.3009 20.9103 20.499 20.7963C20.663 20.7019 20.8185 20.5345 20.9007 20.364C21 20.1582 21 19.9181 21 19.438V16.6207C21 16.2169 21 16.015 20.9335 15.842C20.8749 15.6891 20.7795 15.553 20.6559 15.4456C20.516 15.324 20.3262 15.255 19.9468 15.117L16.74 13.9509C16.2985 13.7904 16.0777 13.7101 15.8683 13.7237C15.6836 13.7357 15.5059 13.7988 15.3549 13.9058C15.1837 14.0271 15.0629 14.2285 14.8212 14.6314L14 16C11.3501 14.7999 9.2019 12.6489 8 10L9.36863 9.17882C9.77145 8.93713 9.97286 8.81628 10.0942 8.64506C10.2012 8.49408 10.2643 8.31637 10.2763 8.1317C10.2899 7.92227 10.2096 7.70153 10.0491 7.26005L8.88299 4.05321C8.745 3.67376 8.67601 3.48403 8.55442 3.3441C8.44701 3.22049 8.31089 3.12515 8.15802 3.06645C7.98496 3 7.78308 3 7.37932 3H4.56201C4.08188 3 3.84181 3 3.63598 3.09925C3.4655 3.18146 3.29814 3.33701 3.2037 3.50103C3.08968 3.69907 3.07375 3.91662 3.04189 4.35173C3.01413 4.73086 3 5.11378 3 5.5Z"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <div className="flex flex-auto flex-col items-start">
                    <div className="flex-auto">
                      <h3 className="text-xl font-medium tracking-tight text-gray-900">
                        Call us
                      </h3>
                    </div>
                    <a
                      href="tel:91 8010961096"
                      className="inline-block text-base font-semibold gradient-text2"
                    >
                      +91 80 1096 1096
                    </a>
                  </div>
                </div>

              </div>
              <div className="mx-auto mt-4 grid max-w-2xl grid-cols-1 gap-6 sm:grid-cols-1 lg:mx-0 lg:max-w-none lg:grid-cols-1">
                <div className="flex flex-col gap-y-12 rounded-2xl border border-[#f0f0f0] p-6 shadow-sm" data-aos="fade-up" data-aos-delay={500}>
                  <div className="flex h-11 w-11 flex-none items-center justify-center rounded-lg btn-gradient">
                    <svg
                      className="h-6 w-6 text-white"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                    >
                      <path
                        d="M12 21C15.5 17.4 19 14.1764 19 10.2C19 6.22355 15.866 3 12 3C8.13401 3 5 6.22355 5 10.2C5 14.1764 8.5 17.4 12 21Z"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <div className="flex flex-auto flex-col items-start">
                    <div className="flex-auto">
                      <h3 className="text-xl font-medium tracking-tight text-gray-900">
                        Address
                      </h3>
                    </div>
                    <p className="inline-block text-base font-semibold gradient-text2">
                      Plot-455, 2nd floor, Najafgarh road, Metro pillar no. 796, New Delhi, 110078
                    </p>
                  </div>
                </div>
              </div>


            </div>
            {/* Right Content - Visual */}
            <div className="relative" data-aos="fade">
              <img src="assets/img/contact.png" className="rounded-[16px]" alt="" />
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Contact;
